import React, { Component, Fragment } from 'react';
import PropTypes from 'proptypes';
import Modal from 'react-modal';
import PortalHeader from './../../lib/portalHeader/PortalHeader';
import Opportunity from './../../lib/opportunity/Opportunity';
import './PortalHome.scss';

export default class PortalHome extends Component {
  componentWillMount() {
    Modal.setAppElement('.sidebar');
    if (this.props.user && this.props.user.trips) {
      let primaryTripId = this.props.user.trips[0].id;
      if (window.sessionStorage.getItem('activeTab') !== null) {
        for (let trip of this.props.user.trips) {
          const storedTripId = window.sessionStorage.getItem('activeTab');
          if (trip.id === storedTripId) {
            primaryTripId = storedTripId;
          }
        }
      }
      this.setState({
        activeTab: primaryTripId,
      });
    }
  }

  componentDidUpdate(prevProps) {
    window.sessionStorage.setItem('activeTab', this.state.activeTab);

    if (this.props.user.trips[0].id !== prevProps.user.trips[0].id) {
      this.setState({
        activeTab: this.props.user.trips[0].id,
      });
    }
  }

  toggleActiveTrip = selectedTab => {
    this.setState({
      activeTab: this.state.activeTab === selectedTab ? this.state.activeTab : selectedTab,
    });
  };

  render() {
    return (
      <Fragment>
        <PortalHeader
          profilePicture={this.props.user.profilePicture ? this.props.user.profilePicture : ''}
          user={this.props.user}
          title={`Welcome, ${this.props.user.name.split(' ')[0]}!`}
          setAppState={this.props.setAppState}
        />
        <Opportunity
          toggleActiveTrip={this.toggleActiveTrip}
          activeTab={this.state.activeTab}
          addTripAddOn={this.props.addTripAddOn}
          user={this.props.user}
          history={this.props.history}
          setParentState={this.props.setParentState}
          handleRouting={this.props.handleRouting}
          deleteTripAddOn={this.props.deleteTripAddOn}
          deleteTripHandler={this.props.deleteTripHandler}
          additionalTripCost={this.props.additionalTripCost}
          updateTripCost={this.props.updateTripCost}
          setTripState={this.props.setTripState}
          setAppState={this.props.setAppState}
          userProps={this.props.userProps}
          isProcessing={this.props.isProcessing}
        />
      </Fragment>
    );
  }
}

PortalHome.propTypes = {
  setAppState: PropTypes.func,
  setTripState: PropTypes.func,
  updateTripCost: PropTypes.func.isRequired,
  additionalTripCost: PropTypes.number,
  setParentState: PropTypes.func.isRequired,
  handleRouting: PropTypes.func.isRequired,
  addTripAddOn: PropTypes.func.isRequired,
  deleteTripAddOn: PropTypes.func.isRequired,
  deleteTripHandler: PropTypes.func.isRequired,
  isProcessing: PropTypes.bool.isRequired,
  userProps: PropTypes.shape({
    birthdate: PropTypes.string,
    gender: PropTypes.string,
    nationality: PropTypes.string,
  }),
};
PortalHome.defaultProps = {
  setAppState: () => {},
  setTripState: () => {},
  userProps: {},
};
